<template>
	<div id="app" >
  <div class="outhtml" v-if="sliderLists.length">
    <!-- /*  顶部滑块 */ -->
      <slider></slider>
      <div class="con-wrap">
          <div class="main-wrap" >
            <!-- /* 内容区域 */ -->
            <part v-for ="(sliderList,index) in sliderLists" :key="index" :sliderList = "sliderList" :index= "index" :scrollTop = "scrollTop" :clientHeight="clientHeight"></part>
          </div>
          <!-- /* 右侧气泡 */ -->
          <transition name = "slide-fade">
            <pop v-show = "isShowPop" @click.native = "popClick"></pop>
          </transition>
      </div>
</div>
<div class="loading" v-else-if="!sliderLists.length">啊哦~没有相应职位，看看别的吧</div>
</div>
</template>
<script>
import {mapState} from 'vuex';
import slider from './components/slider/slider';
import part from './components/part/part';
import pop from './components/pop/pop';
export default{
	components: {
		slider,
		part,
		pop
	},
	computed: {
		...mapState([
			'currentPart',
			'allparts',
			'isShowPop',
			'sliderLists',
			'isShowAllPart'
		])
	},
	data() {
		return {
			isSuccess: true,
			popTimer: null, //右侧气泡定时器
			scrollTop: 0,
			clientHeight: 0
		};
	},
	methods: {
		popClick() {
			this.$store.commit({
				type: 'IS_SHOW_POP',
				state: false
			});
		},
		throttle(method, delay, duration) {
			let timer = null, begin = new Date();
			return function() {
				let context = this, args = arguments, current = new Date();
				clearTimeout(timer);
				if (current - begin >= duration) {
					method.apply(context, args);
					begin = current;
				} else {
					timer = setTimeout(function() {
						method.apply(context, args);
					}, delay);
				}
			};
		}
	},
	watch: {
	//气泡四秒消失
		isShowPop: function(val) {
			if (val) {
				this.popTimer = setTimeout(() => {
					this.$store.commit({
						type: 'IS_SHOW_POP',
						state: false
					});
				}, 4000);
			} else if (!val && this.popTimer) {
				clearTimeout(this.popTimer);
			}
		}
	},
	created() {
		this.$store.commit({type: 'INITINFO'});
	},
	mounted() {
		window.addEventListener('scroll', this.throttle(() => {
			this.scrollTop = document.body.scrollTop;
		}, 100, 200));
		this.clientHeight = document.documentElement.clientHeight;
	}
};
</script>
<style lang="scss">
@import "./src/assets/style/public.scss";

.slide-fade-enter-active,.slide-fade-leave-active{
  transition: all .5s;
  -webkit-transition:all .5s;
}
.slide-fade-enter, .slide-fade-leave-to{ 
  transform:translateX(px2rem(845px));
}
#app{
 height: 100%;
  .outhtml{
      // padding-bottom: px2rem(40px);
      .main-wrap{
        width: 100%;
        overflow: hidden;
        margin-top:px2rem(88px);
        ul{
          width:100%;
        }
      } 
  }
}
.loading{
  text-align:center;
  padding-top:50%;
  font-size:px2rem(36px);
  color:#ccc;
}
  

</style>


// WEBPACK FOOTER //
// App.vue?700613d8